module.exports = __webpack_public_path__ + "email_white.ae1ceedab4caa70214fa.svg";


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/modules/dummy-assets/common/img/icon/svg_icon/email_white.svg
// module id = ../../../../../src/assets/modules/dummy-assets/common/img/icon/svg_icon/email_white.svg
// module chunks = styles